window.onload = function(){
    function gallery(){
        if(document.querySelector('.proFeaturedImage') != null){
            lightGallery(document.querySelector('.proFeaturedImage'), {
                speed: 500,
            });
        }
    }
    gallery();
}